import { render, staticRenderFns } from "./SamePosition.vue?vue&type=template&id=ddcd9f32&scoped=true"
import script from "./SamePosition.vue?vue&type=script&lang=js"
export * from "./SamePosition.vue?vue&type=script&lang=js"
import style0 from "./SamePosition.vue?vue&type=style&index=0&id=ddcd9f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd9f32",
  null
  
)

export default component.exports